module.exports = __webpack_public_path__ + "static/media/23_Bild_6_FES_Team-Cleveland_NicolaPitaro_8098.6990d61e.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/Particles/Particle23/23_Bild_6_FES_Team-Cleveland_NicolaPitaro_8098.jpg
 ** module id = 170
 ** module chunks = 0
 **/